import axios from 'axios'

import { INotice, NoticeParams } from '@/types/notice'

export const createNotice = async (notice: INotice): Promise<INotice> => {
  // eslint-disable-next-line
  const { id, createdAt, updatedAt, deletedAt, ...dto } = notice
  try {
    const response = await axios.post<INotice>('notices', dto)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.notices.createNotice')
  }
}

export const getNotices = async (params: NoticeParams): Promise<INotice[]> => {
  const config = {
    timeout: 1000 * 60 * 10, // 10 min
    params,
  }
  try {
    const response = await axios.get<INotice[]>('notices', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.notices.getNotices')
  }
}

export const getNotice = async (id: number): Promise<INotice> => {
  const config = {}
  try {
    const response = await axios.get<INotice>(`notices/${id}`, config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.notices.getNotice')
  }
}

export const updateNotice = async (notice: INotice): Promise<INotice> => {
  // eslint-disable-next-line
  const { createdAt, updatedAt, deletedAt, ...dto } = notice
  try {
    const response = await axios.put<INotice>(`notices/${notice.id}`, dto)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.notices.updateNotice')
  }
}

export const deleteNotice = async (id: number): Promise<INotice> => {
  try {
    const response = await axios.delete<INotice>(`notices/${id}`)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.notices.deleteNotice')
  }
}
